
<template>
  <div class="limitBox">
    <img class="noData"
         src="../../assets/img/afterLoan/noData.png"
         alt="">
    <p class="noText">您还未完成手机号认证
      快去认证吧！</p>
    <div class="btn"
         @click="getDetails">立即认证</div>
    <p class="info">
      <span>该认证由借款平台提供</span> <br>
      <span>77信用不会获取并保存任何您的运营商信息</span>
    </p>
    <applyModal :propJson="propJson"
                @pageUrl="pageUrl" />
  </div>
</template>

<script>
import applyModal from '@/components/applyModal';
export default {
  components: {
    applyModal
  },
  data () {
    return {
      propJson: {
        isShow: false,
        title: '认证成功',
        info: '查询到您已完成认证快去申请产品吧！',
        btn: '去申请',
        width: true,
        status: '1'
      },
      dataList: [],
      htmlText: '',
      productId: '',
      url: '',
    }
  },
  mounted () {
    this.productId = this.$route.query.productId;
    this.util.title('手机号认证');
    this.queryStatus();
  },
  methods: {
    pageUrl () {
      this.propJson.isShow = false;
      if (this.propJson.status == 1) {//认证成功
        this.toProductDetail();
      } else {
        this.getDetails()//认证接口
      }
    },
    //调用android和ios的方法
    toProductDetail () {
      let json = {
        "pageUrl": this.url
      }
      try {
        window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
      } catch (err) {
        window.AppJs.toProductDetail(JSON.stringify(json));//android
      }
    },
    queryStatus () {
      let _this = this;
      let param = {
        productId: this.productId
      }
      this.$post('/app/v1/operator/hasSuccess', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            if (e.data.auth_state == 1) {
              _this.url = e.data.pageUrl;
              //认证成功
              _this.propJson = {
                isShow: true,
                title: '认证成功',
                info: '查询到您已完成认证快去申请产品吧！',
                btn: '去申请',
                width: true,
                status: '1'
              }
            } else if (e.data.auth_state == 2) {
              _this.url = e.data.pageUrl;
              //认证失败
              _this.propJson = {
                isShow: true,
                title: '认证失败',
                info: '运营商认证失败请前往页面重新操作',
                btn: '重新认证',
                width: true,
                status: '0'
              }
            }

          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    getDetails () {
      let _this = this;
      let param = {
        productId: this.productId
      }
      this.$post('/app/v1/operator/auth', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            let href = e.data.mobileCollectUrl;
            window.location.href = href
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },

  }

}
</script>
<style scoped>
.limitBox {
  background: #fff;
  padding-top: 1.14rem;
  text-align: center;
  position: relative;
}
.noData {
  width: 1.43rem;
  height: 1.22rem;
  margin: 0 auto;
  display: inline-block;
}
.noText {
  width: 1.5rem;
  text-align: center;
  margin: 0 auto;
  color: #666;
  font-size: 0.15rem;
  margin-top: 0.11rem;
  margin-bottom: 0.25rem;
}
.btn {
  width: 2.45rem;
  height: 0.5rem;
  text-align: center;
  color: #fff;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 25px;
  font-size: 0.17rem;
  font-family: PingFangSC;
  font-weight: 500;
  line-height: 0.5rem;
  margin: 0 auto;
}
.info {
  color: #ccc;
  font-size: 0.12rem;
  line-height: 20px;
  text-align: center;
  position: fixed;
  bottom: 0.5rem;
  left: 0;
  width: 100%;
}
</style>
